import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Card, CardBody } from "reactstrap";
import CardHeader from "reactstrap/lib/CardHeader";
import Switch from "src/components/atoms/Switch/Switch";
import TableV3 from "src/components/atoms/TableV3/TableV3";
import { wording } from "src/constants/constants";
import { expandJSON, onFetch } from "src/helpers/helper";
import {
  AET_DASHBOARD,
  CALCULATE_DISTANCE,
  FLEET_FUEL_REPORT_URL,
  SAVE_CALCULATED_DISTANCE,
  SAVE_CALCULATED_FUEL,
} from "src/redux/config/links";

const AETDatatable = ({
  setLoadSummary,
}) => {
  const { authStore } = useSelector((state) => ({
    authStore: state.authStore,
  }));
  const [calFuel, setCalFuel] = useState(true);
  const [isFetchingAllFuel, setIsFetchingAllFuel] = useState(false);
  const [loadFetchingAllFuel, setLoadFetchingAllFuel] = useState(true);
  const [isCalAllFuel, setIsCalAllFuel] = useState(false);

  const [calDistance, setCalDistance] = useState(false);
  const [isFetchingAllDistance, setIsFetchingAllDistance] = useState(false);
  const [loadFetchingAllDistance, setLoadFetchingAllDistance] = useState(true);
  const [isCalAllDistance, setIsCalAllDistance] = useState(false);

  const [sort, setSort] = useState([]);
  const [filter, setFilter] = useState([]);
  const [page, setPage] = useState({
    of: 1,
    size: 20,
  });

  const [oneTime, setOneTime] = useState(true);
  const [loadContent, setLoadContent] = useState(false);
  const [userList, setUserList] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const onUserList = useCallback(
    ({ page, sort, filter, show = [] }) => {
      setLoading(true);
      let newFilter = {};
      Object.keys(filter).forEach((item) => {
        newFilter = { ...newFilter, [item]: encodeURI(`%${filter[item]}%`) };
      });

      const query = expandJSON({ page, sort, filter: newFilter, show })
        .map((item) => `${item.label}=${item.value}`)
        .join("&");
      axios({
        url: `${AET_DASHBOARD}?${query}`,
        method: "POST",
        headers: {
          Authorization: authStore.authData.result.token,
        },
      })
        .then((result) => {
          setLoading(false);
          setUserList(result.data);
        })
        .catch(() => {
          setLoading(false);
        });
    },
    [authStore.authData.result.token]
  );

  const fetchFuelConsumption = useCallback(
    (id_fleet, startDate, endDate, id_do, clicked=false, cb = () => null) => {
      onFetch(
        !!authStore.authData?authStore.authData.result.token:null,
        {
          url: FLEET_FUEL_REPORT_URL,
          data: {
            id: id_fleet,
            start_date: startDate,
            end_date: endDate,
          },
          type: "json",
        },
        {
          beforeSend: () => {
            setUserList((prev) => ({
              ...prev,
              result: {
                ...prev.result,
                data: prev.result.data.map((item) =>
                  item.id === id_do
                    ? {
                        ...item,
                        calculated_fuel_consumption: "loading",
                        calculated_carbon: "loading",
                      }
                    : item
                ),
              },
            }));
          },
          success: (res) => {
            setUserList((prev) => ({
              ...prev,
              result: {
                ...prev.result,
                data: prev.result.data.map((item) =>
                  item.id === id_do
                    ? {
                        ...item,
                        calculated_fuel_consumption: res.data.fuel_consumption,
                        calculated_carbon: res.data.carbon,
                      }
                    : item
                ),
              },
            }));

            onFetch(
        !!authStore.authData?authStore.authData.result.token:null,
              {
                url: SAVE_CALCULATED_FUEL,
                data: {
                  delivery_order_id: id_do,
                  calculated_fuel_consumption: res.data.fuel_consumption,
                  calculated_carbon: res.data.carbon,
                },
                type: "json",
              },
              {
                beforeSend: () => null,
                success: () => {
                  if(clicked){
                    setLoadSummary(true);
                  }
                  cb()
                },
                error: () => cb(),
              }
            );
          },
          error: () => {
            setUserList((prev) => ({
              ...prev,
              result: {
                ...prev.result,
                data: prev.result.data.map((item) =>
                  item.id === id_do
                    ? {
                        ...item,
                        calculated_fuel_consumption: null,
                        calculated_carbon: null,
                      }
                    : item
                ),
              },
            }));
            cb();
          },
        }
      );
    },
    [authStore.authData, setLoadSummary]
  );

  const infiniteFetchFuelConsump = useCallback(
    (arr, index, cb) => {
      if (arr.length > 0) {
        const current = arr[index];

        if (!!current.id_fleet) {
          fetchFuelConsumption(
            current.id_fleet,
            current.assigned_do_date,
            current.end_assigned_do_date,
            current.id,
            false,
            () => {
              if (arr.length > index + 1) {
                infiniteFetchFuelConsump(arr, index + 1, cb);
              } else {
                cb();
              }
            }
          );
        } else {
          if (arr.length > index + 1) {
            infiniteFetchFuelConsump(arr, index + 1, cb);
          } else {
            cb();
          }
        }
      } else {
        cb();
      }
    },
    [fetchFuelConsumption]
  );

  const fetchDistance = useCallback(
    (id_fleet, startDate, endDate, id_do, cb = () => null) => {
      onFetch(
        !!authStore.authData?authStore.authData.result.token:null,
        {
          url: CALCULATE_DISTANCE,
          data: {
            fleet_id: id_fleet,
            start_date: startDate,
            end_date: endDate,
          },
          type: "json",
        },
        {
          beforeSend: () => {
            setUserList((prev) => ({
              ...prev,
              result: {
                ...prev.result,
                data: prev.result.data.map((item) =>
                  item.id === id_do
                    ? {
                        ...item,
                        calculated_distance: "loading",
                      }
                    : item
                ),
              },
            }));
          },
          success: (res) => {
            setUserList((prev) => ({
              ...prev,
              result: {
                ...prev.result,
                data: prev.result.data.map((item) =>
                  item.id === id_do
                    ? {
                        ...item,
                        calculated_distance:
                          res.data.result.calculated_distance,
                      }
                    : item
                ),
              },
            }));

            onFetch(
        !!authStore.authData?authStore.authData.result.token:null,
              {
                url: SAVE_CALCULATED_DISTANCE,
                data: {
                  delivery_order_id: id_do,
                  calculated_distance: res.data.result.calculated_distance,
                },
                type: "json",
              },
              {
                beforeSend: () => null,
                success: () => cb(),
                error: () => cb(),
              }
            );
          },
          error: () => {
            setUserList((prev) => ({
              ...prev,
              result: {
                ...prev.result,
                data: prev.result.data.map((item) =>
                  item.id === id_do
                    ? {
                        ...item,
                        calculated_distance: null,
                      }
                    : item
                ),
              },
            }));
            cb();
          },
        }
      );
    },
    [authStore.authData]
  );

  const infiniteFetchDistance = useCallback(
    (arr, index, cb) => {
      if (arr.length > 0) {
        const current = arr[index];

        if (!!current.id_fleet) {
          fetchDistance(
            current.id_fleet,
            current.assigned_do_date,
            current.end_assigned_do_date,
            current.id,
            () => {
              if (arr.length > index + 1) {
                infiniteFetchDistance(arr, index + 1, cb);
              } else {
                cb();
              }
            }
          );
        } else {
          if (arr.length > index + 1) {
            infiniteFetchDistance(arr, index + 1, cb);
          } else {
            cb();
          }
        }
      } else {
        cb();
      }
    },
    [fetchDistance]
  );

  useEffect(() => {
    if (oneTime) {
      setOneTime(false);
      if (!!!userList) {
        setLoadContent(true);
      }
    }
  }, [userList, oneTime]);

  useEffect(() => {
    if (loadContent) {
      setLoadContent(false);
      setLoadFetchingAllFuel(true);
      setLoadFetchingAllDistance(true);
      onUserList({
        page: page,
        sort:
          sort.length === 0
            ? [
                {
                  by: "created_on",
                  order: "desc",
                },
              ]
            : sort,
        filter: filter,
        show: [
          "id",
          "leftJoin_companycanview_name",
          "leftJoin_company_name",
          "leftJoin_fleet_reg_number",
          "total_est_carbon",
          "id_fleet",
          "assigned_do_date",
          "end_assigned_do_date",
          "calculated_fuel_consumption",
          "calculated_distance",
          "calculated_carbon",
        ],
      });
    }
  }, [filter, page, sort, loadContent, onUserList]);

  useEffect(() => {
    if (calFuel && !!userList && !isLoading && loadFetchingAllFuel) {
      setLoadFetchingAllFuel(false);
      setIsFetchingAllFuel(true);
    }
  }, [calFuel, userList, loadFetchingAllFuel, isLoading]);

  useEffect(() => {
    if (calDistance && !!userList && !isLoading && loadFetchingAllDistance) {
      setLoadFetchingAllDistance(false);
      setIsFetchingAllDistance(true);
    }
  }, [calDistance, userList, loadFetchingAllDistance, isLoading]);

  useEffect(() => {
    if (isFetchingAllFuel) {
      setIsFetchingAllFuel(false);
      setIsCalAllFuel(true);
      infiniteFetchFuelConsump(
        userList.result.data.filter(
          (item) =>
            item.calculated_fuel_consumption === null ||
            item.calculated_carbon === null
        ),
        0,
        () => {
          // done
          setIsCalAllFuel(false);
          setLoadSummary(true);
        }
      );
    }
  }, [userList, isFetchingAllFuel, infiniteFetchFuelConsump, setLoadSummary]);

  useEffect(() => {
    if (isFetchingAllDistance) {
      setIsFetchingAllDistance(false);
      setIsCalAllDistance(true);
      infiniteFetchDistance(
        userList.result.data.filter(
          (item) => item.calculated_distance === null
        ),
        0,
        () => {
          // done
          setIsCalAllDistance(false);
        }
      );
    }
  }, [userList, isFetchingAllDistance, infiniteFetchDistance]);

  return (
    <>
      <Card>
        <CardHeader>Delivery Order</CardHeader>
        <CardBody>
          <div style={{ display: "flex", gap: 16 }}>
            <Button
              color="primary"
              type="button"
              onClick={() => setLoadContent(true)}
            >
              Reload
            </Button>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              Calculate all Fuel and Carbon:{" "}
              <Switch
                toggle={calFuel}
                onChange={(e) => setCalFuel(e)}
                size={0.5}
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              Calculate all Distance:{" "}
              <Switch
                toggle={calDistance}
                onChange={(e) => setCalDistance(e)}
                size={0.5}
              />
            </div>
          </div>
          <TableV3
            sort={sort}
            onSort={(s) => {
              setSort([...s]);
              setPage({ ...page, of: 1 });
              setLoadContent(true);
            }}
            page={page}
            totalPage={
              Math.ceil(
                ((!!userList ? userList.result.total : 1) ?? 1) / page.size
              ) ?? 1
            }
            onPage={(page) => {
              setPage(page);
              setLoadContent(true);
            }}
            filter={filter}
            onFilter={(f) => {
              setFilter(f);
              setPage({ ...page, of: 1 });
              setLoadContent(true);
            }}
            data={!!userList ? userList.result.data : []}
            columns={[
              {
                name: wording["DO"]+" ID",
                field: "id",
                sortable: true,
                searchable: true,
              },
              {
                name: "Company",
                field: "leftJoin_company_name",
                sortable: true,
                searchable: true,
              },
              {
                name: "Fleet",
                field: "leftJoin_fleet_reg_number",
                sortable: true,
                searchable: true,
              },
              {
                name: "Routes",
                field: "workorders",
                render: (cell) => {
                  return cell.data
                    .filter((item) => !!item.savedplace)
                    .map((item) => item.savedplace.name)
                    .join(" → ");
                },
              },
              {
                name: "Fuel Consump.",
                field: "calculated_fuel_consumption",
                render: (
                  cell,
                  {
                    id,
                    id_fleet,
                    assigned_do_date,
                    end_assigned_do_date,
                    calculated_fuel_consumption,
                  }
                ) => {
                  return (
                    <>
                      {calculated_fuel_consumption === null ? (
                        <Button
                          color="primary"
                          type="button"
                          disabled={isCalAllFuel}
                          onClick={() =>
                            fetchFuelConsumption(
                              id_fleet,
                              assigned_do_date,
                              end_assigned_do_date,
                              id,
                              true
                            )
                          }
                        >
                          Calculate
                        </Button>
                      ) : (
                        <>
                          {calculated_fuel_consumption !== "loading" ? (
                            <>
                              {calculated_fuel_consumption.toFixed(2)} <br />
                              <Button
                                color="secondary"
                                type="button"
                                disabled={isCalAllFuel}
                                onClick={() =>
                                  fetchFuelConsumption(
                                    id_fleet,
                                    assigned_do_date,
                                    end_assigned_do_date,
                                    id,
                                    true
                                  )
                                }
                              >
                                Recalculate{" "}
                              </Button>
                            </>
                          ) : (
                            calculated_fuel_consumption
                          )}
                        </>
                      )}
                    </>
                  );
                },
              },
              {
                name: "Distance",
                field: "calculated_distance",
                render: (
                  cell,
                  {
                    id,
                    id_fleet,
                    assigned_do_date,
                    end_assigned_do_date,
                    calculated_distance,
                  }
                ) => {
                  return (
                    <>
                      {calculated_distance === null ? (
                        <Button
                          color="primary"
                          type="button"
                          disabled={isCalAllDistance}
                          onClick={() =>
                            fetchDistance(
                              id_fleet,
                              assigned_do_date,
                              end_assigned_do_date,
                              id
                            )
                          }
                        >
                          Calculate
                        </Button>
                      ) : (
                        <>
                          {calculated_distance !== "loading" ? (
                            <>
                              {(calculated_distance / 1000).toFixed(2)} km{" "}
                              <br />
                              <Button
                                color="secondary"
                                type="button"
                                disabled={isCalAllDistance}
                                onClick={() =>
                                  fetchDistance(
                                    id_fleet,
                                    assigned_do_date,
                                    end_assigned_do_date,
                                    id
                                  )
                                }
                              >
                                Recalculate{" "}
                              </Button>
                            </>
                          ) : (
                            calculated_distance
                          )}
                        </>
                      )}
                    </>
                  );
                },
              },
              {
                name: "Cargo Weight",
                field: "workorders",
                render: (cell) => {
                  return (
                    [0, 0, 0, ...cell.data.map((item) => item.cargo_weight)]
                      .reduce((a, b) => a + b)
                      .toFixed(2) + " kg"
                  );
                },
              },
              {
                name: "Total Carbon",
                field: "calculated_carbon",
                render: (
                  cell,
                  {
                    id,
                    id_fleet,
                    assigned_do_date,
                    end_assigned_do_date,
                    calculated_carbon,
                  }
                ) => {
                  return (
                    <>
                      {calculated_carbon === null ? (
                        <Button
                          color="primary"
                          type="button"
                          disabled={isCalAllFuel}
                          onClick={() =>
                            fetchFuelConsumption(
                              id_fleet,
                              assigned_do_date,
                              end_assigned_do_date,
                              id,
                              true
                            )
                          }
                        >
                          Calculate
                        </Button>
                      ) : (
                        <>
                          {calculated_carbon !== "loading" ? (
                            <>
                              {calculated_carbon.toFixed(2)} kg/CO2 <br />
                              <Button
                                color="secondary"
                                type="button"
                                disabled={isCalAllFuel}
                                onClick={() =>
                                  fetchFuelConsumption(
                                    id_fleet,
                                    assigned_do_date,
                                    end_assigned_do_date,
                                    id,
                                    true
                                  )
                                }
                              >
                                Recalculate{" "}
                              </Button>
                            </>
                          ) : (
                            <>{calculated_carbon}</>
                          )}
                        </>
                      )}
                    </>
                  );
                },
              },
              {
                name: wording["DO"]+" Start Date",
                field: "assigned_do_date",
                sortable: true,
                searchable: true,
              },
              {
                name: wording["DO"]+" End Date",
                field: "end_assigned_do_date",
                sortable: true,
                searchable: true,
              },
            ]}
            loading={isLoading}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default AETDatatable;
